const applyAlign = () => {
    if (window.innerWidth < 1024) {
        document.querySelectorAll('[data-align-to]').forEach((target) => {
            target.style.marginTop = ''
        })
        return
    }

    document.querySelectorAll('[data-align-to]').forEach((target) => {
        const id = target.getAttribute('data-align-to')
        const ref = document.querySelector(`[data-align-id="${id}"]`)
        if (!ref) return

        const refRect = ref.getBoundingClientRect()
        const lastEl = ref.lastElementChild || ref
        const refMarginBottom = parseFloat(
            getComputedStyle(lastEl).marginBottom
        )
        const delta =
            (refRect.height || 0) +
            (Number.isNaN(refMarginBottom) ? 0 : refMarginBottom)

        target.style.marginTop = `${Math.round(delta)}px`
    })
}

document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('load', () => {
        applyAlign()
    })

    window.addEventListener('resize', () => {
        applyAlign()
    })
})
